import React from 'react';
import { Task } from '../../types';

export function EscalatedPill({ task }: { task: Task }) {
  const email = task.escalatedByEmail?.trim();
  if (!email) return null;
  return (
    <span className="rounded-full bg-amber-50 px-2 py-0.5 font-medium text-amber-800">
      Escalated · {email}
    </span>
  );
}
